module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_c('span', {
    staticClass: "tocs"
  }, [_vm._v("CHAPTER 1")]), _c('br'), _vm._v("For You and Your Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#sec1"
    }
  }, [_vm._v("Laptop Sleeve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#sec2"
    }
  }, [_vm._v("Phone Case Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#sec3"
    }
  }, [_vm._v("Bookmark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#sec4"
    }
  }, [_vm._v("Washi Bead Necklace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#sec5"
    }
  }, [_vm._v("Initial Necklace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#sec6"
    }
  }, [_vm._v("Braided Friendship Bracelet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#sec7"
    }
  }, [_vm._v("Toilet Paper Roll Bracelet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#sec8"
    }
  }, [_vm._v("Popsicle Stick Bracelet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#sec9"
    }
  }, [_vm._v("Feather Dangle Earrings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#sec10"
    }
  }, [_vm._v("Stud Earrings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#sec11"
    }
  }, [_vm._v("Bobby Pin Flower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#sec12"
    }
  }, [_vm._v("Bow Ring")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#sec13"
    }
  }, [_vm._v("Barrette")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocs"
  }, [_vm._v("CHAPTER 2")]), _c('br'), _vm._v("For Your Room")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c02#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washi Tape Keyboard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c02#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charger and Cable Markers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c02#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tin Can Organizer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c02#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drawer Organizer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c02#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Upcycled Desk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c02#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wall Calendar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c02#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jewelry Organizer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c02#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shoebox Upcycle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c02#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Light Switch Plate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c02#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cutout Art")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c02#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quote Art")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c02#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Temporary Wallpaper")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c02#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bed Headboard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocs"
  }, [_vm._v("CHAPTER 3")]), _c('br'), _vm._v("For the Holidays")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c03#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Birthday Candle Card")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c03#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valentine’s Day Card")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c03#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valentine’s Day Heart Streamers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c03#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twist Ties")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c03#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christmas Matchbox Drawers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c03#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candy Cane Christmas Ornament")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c03#sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christmas Tree Card")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocs"
  }, [_vm._v("CHAPTER 4")]), _c('br'), _vm._v("For School")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Locker Pen and Pencil Holder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Locker Mirror")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Locker Dry-Erase Board")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magnets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paper Clip Bookmark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cloud and Raindrop Bookmark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pencil Case Roll")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washi Tape Pens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washi Tape Pencils")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Supply Labels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Organization Labels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Textbook Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Composition Book")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washi Tape Stickers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007288a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 60
// module chunks = 0